import {ProcessType} from "./process-type";

export class Transformation {
    processType: ProcessType;
    template: any;
    input: any;
    inputContentType: string;
    output: any;
    outputContentType: string;
    errorInd: boolean;
    message: string;
}
